import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { Tab, Tabs } from '@material-ui/core';
import 'react-datepicker/dist/react-datepicker.css';
import TabPanel from 'components/TabPanel';
import { Calendar } from 'react-calendar';
import ExtendedDatePicker from './ExtendedDatePicker';

const useStyles = makeStyles(theme => ({
  selectRoot: {
    '&:hover': {
      color: theme.palette.primary.main,
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.accent.main
      }
    }
  },
  selectInput: {
    padding: '10px'
  },
  centerComponent: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center'
  }
}));

const ConditionalCustomDate = ({
  component,
  handleSetStartDate,
  startDateState,
  endDateState,
  handleSetEndDate
}) => {
  const classes = useStyles();

  const [value, setValue] = React.useState(1);
  const [visitedEndDate, setVisitedEndDate] = React.useState(false);

  useEffect(() => {
    setValue(1);
    setVisitedEndDate(false);
  }, [component]);

  const handleTabsChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleStartDateChange = newDate => {
    handleSetStartDate(newDate);
  };

  const handleEndDateChange = newDate => {
    handleSetEndDate(newDate);
  };

  const handleSettingDates = newDate => {
    if (value === 0 && !visitedEndDate) {
      handleSetStartDate(newDate);
    }

    handleSetEndDate(newDate);
  };
  switch (component) {
    case '1':
      return (
        <>
          <Tabs
            value={value}
            variant="fullWidth"
            indicatorColor="primary"
            onChange={handleTabsChange}
          >
            <Tab label="Start Date" value={0} key={0} disableRipple />
            <Tab
              onClick={() => setVisitedEndDate(true)}
              label="End Date"
              value={1}
              key={1}
              disableRipple
            />
          </Tabs>

          <TabPanel className={classes.centerComponent} value={value} index={0}>
            <ExtendedDatePicker
              isEndVisited={visitedEndDate}
              isQuarter
              isStarterComponent
              handleSetStartDate={handleSetStartDate}
              startDateState={startDateState}
              endDateState={endDateState}
              handleSetEndDate={handleSetEndDate}
            />
          </TabPanel>
          <TabPanel className={classes.centerComponent} value={value} index={1}>
            <ExtendedDatePicker
              isEndVisited={visitedEndDate}
              isQuarter
              handleSetStartDate={handleSetStartDate}
              startDateState={startDateState}
              endDateState={endDateState}
              handleSetEndDate={handleSetEndDate}
            />
          </TabPanel>
        </>
      );
    case '2':
      return (
        <>
          <Tabs
            value={value}
            variant="fullWidth"
            indicatorColor="primary"
            onChange={handleTabsChange}
          >
            <Tab label="Start Date" value={0} key={0} disableRipple />
            <Tab
              onClick={() => setVisitedEndDate(true)}
              label="End Date"
              value={1}
              key={1}
              disableRipple
            />
          </Tabs>

          <TabPanel className={classes.centerComponent} value={value} index={0}>
            <ExtendedDatePicker
              isEndVisited={visitedEndDate}
              isStarterComponent
              handleSetStartDate={handleSetStartDate}
              startDateState={startDateState}
              endDateState={endDateState}
              handleSetEndDate={handleSetEndDate}
            />
          </TabPanel>
          <TabPanel className={classes.centerComponent} value={value} index={1}>
            <ExtendedDatePicker
              isEndVisited={visitedEndDate}
              handleSetStartDate={handleSetStartDate}
              startDateState={startDateState}
              endDateState={endDateState}
              handleSetEndDate={handleSetEndDate}
            />
          </TabPanel>
        </>
      );
    case '3':
      return (
        <>
          <Tabs
            value={value}
            variant="fullWidth"
            indicatorColor="primary"
            onChange={handleTabsChange}
          >
            <Tab label="Start Date" value={0} key={0} disableRipple />
            <Tab
              onClick={() => setVisitedEndDate(true)}
              label="End Date"
              value={1}
              key={1}
              disableRipple
            />
          </Tabs>
          <TabPanel value={value} index={0}>
            <Calendar
              isEndVisited={visitedEndDate}
              onChange={handleSettingDates}
              value={startDateState}
            />
          </TabPanel>

          <TabPanel value={value} index={1}>
            <Calendar
              isEndVisited={visitedEndDate}
              onChange={handleSettingDates}
              value={endDateState}
            />
          </TabPanel>
        </>
      );
    default:
      return <>NOINFO</>;
  }
};

ConditionalCustomDate.propTypes = {
  component: PropTypes.string.isRequired,
  handleSetEndDate: PropTypes.func.isRequired,
  handleSetStartDate: PropTypes.func.isRequired,
  endDateState: PropTypes.instanceOf(Date).isRequired,
  startDateState: PropTypes.instanceOf(Date).isRequired
};

export default ConditionalCustomDate;
